import {useRef, useEffect} from 'react';

export default function usePrevious(value) {
    const previousRef = useRef();
    useEffect(() => {
        previousRef.current = value;
    }, [value]);
    return previousRef.current;
}



// WEBPACK FOOTER //
// ./src/hooks/usePrevious.js